import { CustomAxios } from "@shared/api/axiosClient";

import type { Schemas } from "@shared/api/types";

export type CommissionPayment = Schemas["CommissionPaymentDTO"];

// Capa HTTP del dominio commission. Funciones puras: entran params, sale
// Promise<data>. La auth la adjunta el interceptor axios compartido.

export const getCommissionPayments = (): Promise<CommissionPayment[]> =>
  CustomAxios.get("commission-payments").then(({ data }) => data);
